import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export type TimeBasedGreetingReturn = {
  greeting: string;
  bgImg: string;
  retestBgImg: string;
};

export const getTimeBasedGreetingAndBgImg = (): TimeBasedGreetingReturn => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const localHour = dayjs().tz(userTimezone).hour();
  const localMinute = dayjs().tz(userTimezone).minute();

  const currentTime = localHour + localMinute / 60;

  if (currentTime >= 0 && currentTime < 12) {
    return {
      greeting: 'Good morning',
      bgImg: 'good_morning_background.jpg',
      retestBgImg: 'good_morning_retest_background.jpg',
    };
  } else if (currentTime >= 12 && currentTime < 17) {
    return {
      greeting: 'Good afternoon',
      bgImg: 'good_afternoon_background.jpg',
      retestBgImg: 'good_afternoon_retest_background.jpg',
    };
  } else {
    return {
      greeting: 'Good evening',
      bgImg: 'good_evening_background.jpg',
      retestBgImg: 'good_evening_retest_background.jpg',
    };
  }
};

export const isRecentlyPublished = (dateString?: string): boolean => {
  if (!dateString) {
    return false;
  }
  // Parse the input date string
  const givenDate = new Date(dateString);
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const differenceInMs = currentDate.getTime() - givenDate.getTime();

  // Convert milliseconds to days
  const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);

  // Check if difference is between 0 and 7 days
  return differenceInDays >= 0 && differenceInDays <= 7;
};
